module.exports = __webpack_public_path__ + "static/media/google_developers_club_logo.a0de9685.svg";